import { projectTOC } from "./projectTOC";

const THUMBNAIL_DIR = "images/project-thumbnails";

const projectEntry = (title, slug, thumbnail, tocKey) => {
  const { overview, overviewLead, tags } = projectTOC[tocKey];
  const summary = overviewLead ? `${overviewLead} ${overview}` : overview;

  return {
    title,
    imgSrc: `${THUMBNAIL_DIR}/${thumbnail}`,
    link: `/projects/${slug}`,
    summary,
    tags,
  };
};

const projects = [
  projectEntry("Project Eversio", "eversio", "Eversio-Thumb.webp", "eversio"),
  projectEntry(
    "LifeCanvas",
    "lifecanvas",
    "LifeCanvas-Thumb.webp",
    "lifeCanvas",
  ),
  projectEntry("iCook", "icook", "iCook-Thumb.webp", "icook"),
  projectEntry(
    "Funzies Collection",
    "funzies-collection",
    "Funzies-Thumb.webp",
    "funzies",
  ),
  projectEntry("Sound Art", "soundart", "SoundArt-Thumb.webp", "soundArt"),
  projectEntry(
    "80s Aesthetic Art Gallery",
    "aesthetic-art-gallery",
    "AestheticArtGallery-Thumb.webp",
    "aestheticGallery",
  ),
  projectEntry(
    "Custom PC Builder System",
    "custom-pc-builder",
    "CustomPCBuilder-Thumb.webp",
    "customPCBuilder",
  ),
];

export default projects;
